import { IconButton, Tooltip, useTheme } from "@mui/material"
import InsertPhotoOutlinedIcon from "@mui/icons-material/InsertPhotoOutlined"
import { useTranslation } from "react-i18next"

type PlotDialogIconProps = {
  onClick: () => void
}

const PlotDialogIcon = ({ onClick }: PlotDialogIconProps) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Tooltip title={t("plots_descriptions.CLICK_FOR_DIAGRAM")} arrow>
      <IconButton
        onClick={onClick}
        disableRipple
        sx={{
          padding: 0,
          "&:hover": {
            color: theme.palette.primary.main,
          },
        }}
      >
        <InsertPhotoOutlinedIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  )
}

export default PlotDialogIcon
